import { ADFORM_PREBID_BIDDER, RTBHOUSE_PREBID_BIDDER, TURK_TELEKOM_PREBID_BIDDER, YANDEX_PREBID_BIDDER } from '../bidders';

export const gameAdUnits = {
  desktop: {
    oyunlarMasthead: {
      name: 'Onedio.com_Desktop_Masthead_Oyunlar',
      sizes: [
        [1100, 130],
        [970, 250],
        [1100, 250],
        [970, 130],
        [728, 90],
        [980, 250],
        [940, 250],
      ],
      cls: 'max',
      collapse: false,
      prebid: {
        bids: [ADFORM_PREBID_BIDDER(1010076), RTBHOUSE_PREBID_BIDDER, TURK_TELEKOM_PREBID_BIDDER, YANDEX_PREBID_BIDDER('R-A-3025919-1')],
      },
    },
    oyunlarInpage1: {
      name: 'Onedio.com_Desktop_Oyunlar_inpage_1',
      sizes: [[728, 90], [970, 90], [1100, 130], 'fluid'],
      prebid: {
        bids: [ADFORM_PREBID_BIDDER(1726233), RTBHOUSE_PREBID_BIDDER, TURK_TELEKOM_PREBID_BIDDER, YANDEX_PREBID_BIDDER('R-A-3025919-1')],
      },
    },
    oyunlarInpage2: {
      name: 'Onedio.com_Desktop_Oyunlar_inpage_2',
      sizes: [[250, 250], [300, 250], 'fluid', [336, 280]],
      prebid: {
        bids: [ADFORM_PREBID_BIDDER(1666467), RTBHOUSE_PREBID_BIDDER, TURK_TELEKOM_PREBID_BIDDER, YANDEX_PREBID_BIDDER('R-A-3025919-1')],
      },
    },
    oyunlarInpage3: {
      name: 'Onedio.com_Desktop_Oyunlar_inpage_3',
      sizes: [[336, 280], 'fluid', [250, 250], [300, 250]],
      prebid: {
        bids: [ADFORM_PREBID_BIDDER(1666467), RTBHOUSE_PREBID_BIDDER, TURK_TELEKOM_PREBID_BIDDER, YANDEX_PREBID_BIDDER('R-A-3025919-1')],
      },
    },
    oyunlarSkyscrapperLeft: {
      name: 'Onedio.com_Desktop_Oyunlar_skyscrapper_left',
      refreshTimer: 30,
      sizes: [[120, 600], 'fluid', [160, 600]],
    },
    oyunlarSkyscrapperRight: {
      name: 'Onedio.com_Desktop_Oyunlar_skyscrapper_right',
      refreshTimer: 30,
      sizes: [[120, 600], 'fluid', [160, 600]],
    },
    oyunlarFooter: {
      name: 'Onedio.com_Desktop_Footer',
      sizes: [[728, 90], [970, 90], 'fluid'],
      prebid: {
        bids: [ADFORM_PREBID_BIDDER(1726233), RTBHOUSE_PREBID_BIDDER, TURK_TELEKOM_PREBID_BIDDER, YANDEX_PREBID_BIDDER('R-A-3025919-1')],
      },
    },
  },
  mobile: {
    oyunlarMasthead: {
      name: 'Onedio.com_Mobile_Masthead_Oyunlar',
      sizes: [[300, 50], [300, 100], 'fluid', [320, 50], [320, 100]],
      cls: 'max',
      collapse: false,
      prebid: {
        bids: [ADFORM_PREBID_BIDDER(1012352), RTBHOUSE_PREBID_BIDDER, TURK_TELEKOM_PREBID_BIDDER, YANDEX_PREBID_BIDDER('R-A-3025919-2')],
      },
    },
    oyunlarInpage1: {
      name: 'Onedio.com_Mobile_Oyunlar_inpage_1',
      sizes: [[320, 100], [300, 50], [336, 280], [300, 100], [300, 250], [250, 250], 'fluid', [320, 50]],
      prebid: {
        bids: [ADFORM_PREBID_BIDDER(1674488), RTBHOUSE_PREBID_BIDDER, TURK_TELEKOM_PREBID_BIDDER, YANDEX_PREBID_BIDDER('R-A-3025919-2')],
      },
    },
    oyunlarInpage2: {
      name: 'Onedio.com_Mobile_Oyunlar_inpage_2',
      sizes: [[300, 250], 'fluid', [300, 100], [300, 50], [320, 100], [320, 50], [250, 250], [336, 280]],
      prebid: {
        bids: [ADFORM_PREBID_BIDDER(1674488), RTBHOUSE_PREBID_BIDDER, TURK_TELEKOM_PREBID_BIDDER, YANDEX_PREBID_BIDDER('R-A-3025919-2')],
      },
    },
    oyunlarInpage3: {
      name: 'Onedio.com_Mobile_Oyunlar_inpage_3',
      sizes: [[320, 100], [250, 250], [336, 280], [300, 100], [300, 250], 'fluid', [300, 50], [320, 50]],
      prebid: {
        bids: [ADFORM_PREBID_BIDDER(1674488), RTBHOUSE_PREBID_BIDDER, TURK_TELEKOM_PREBID_BIDDER, YANDEX_PREBID_BIDDER('R-A-3025919-2')],
      },
    },
  },
};
